import { noop, type QueryClient } from '@tanstack/react-query';
import { type createStatsigUpdateUserQuery } from '@/api/services/statsig';

type EnsureStatsigUserFeatureGateReadyContext = {
  queryClient: QueryClient;
  statsigUser: Promise<ReturnType<typeof createStatsigUpdateUserQuery>>;
};

export const ensureStatsigUserFeatureGateReady = async (context: EnsureStatsigUserFeatureGateReadyContext) =>
  context.queryClient.fetchQuery(await context.statsigUser).then(noop);
